import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import LawDirectory from './pages/LawDirectory';
import AdminUploadPortal from './pages/AdminUploadPortal';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';

import StatutesDirectory from './pages/StatutesDirectory';
import SmartLegalDrafting from './pages/SmartLegalDrafting';
import AiAssistant from './pages/AiAssistant';
import VideoConferencePage from './pages/VideoConferencePage';
import DownloadsPage from './pages/DownloadsPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/cases/search" element={<LawDirectory />} />
            <Route path="/statutes/search" element={<StatutesDirectory />} />
            <Route path="/statutes" element={<StatutesDirectory />} />
            <Route path="/search" element={<LawDirectory />} />
            <Route path="/law-directory" element={<LawDirectory />} />
            <Route path="/lawyers" element={<LawDirectory />} />
            <Route path="/smart-legal-drafting" element={<SmartLegalDrafting />} />
            <Route path="/drafting" element={<SmartLegalDrafting />} />
            <Route path="/ai-drafting" element={<SmartLegalDrafting />} />
            <Route path="/ai-assistant" element={<AiAssistant />} />
            <Route path="/ai" element={<AiAssistant />} />
            <Route path="/conference" element={<VideoConferencePage />} />
            <Route path="/meet" element={<VideoConferencePage />} />
            <Route path="/video-conference" element={<VideoConferencePage />} />
            <Route path="/admin/upload" element={<AdminUploadPortal />} />
            <Route path="/admin/portal" element={<AdminUploadPortal />} />
            <Route path="/admin/news" element={<AdminUploadPortal />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/publications" element={<DownloadsPage />} />
            <Route path="/digital-library" element={<DownloadsPage />} />
            <Route path="/terms" element={<div style={{ padding: '2rem' }}><h1>Terms & Conditions</h1><p>Elum Law Directory Terms of Service.</p></div>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
